/*
 * 2021-06-25 lee
 * 升级工单
 */
import { ticketClient } from "@/api/index";
import { ManualUpgradeTicketReq } from "@/pbjs/xcommon/ticket_pb.js";
import InnerRequest from "./request";
//   升级工单所需要的参数
interface Options {
    OverdueDay: number;
}
export function setManualUpgradeTicketReq(arg: Options) {
    let request: any = new ManualUpgradeTicketReq();
    request.setOverdueday(arg.OverdueDay);
    return request;
}
export const getManualUpgradeTicketRequest = new InnerRequest(
    ticketClient,
    ticketClient.manualUpgradeTicket
);
